import DomainGroupAPI from '@/api/DomainGroupApi';
import * as types from './types';

export default {
  async all({ commit, dispatch }, params) {
    dispatch('application/startLoading', null, { root: true });
    try {
      return await DomainGroupAPI.findAll(params).then((response) => {
        commit(types.SET_DOMAIN_GROUPS, response.data.data);
        commit(types.SET_PAGINATION, response.data.pagination);
        return response;
      });
    } catch (error) {
      dispatch('application/openSnackbar', {
        message: error.message,
      }, { root: true });
      throw error;
    } finally {
      dispatch('application/finishLoading', null, { root: true });
    }
  },
  async find({ commit, dispatch }, params) {
    dispatch('application/startLoading', null, { root: true });
    try {
      return await DomainGroupAPI.findById(params).then((response) => {
        commit(types.SET_CURRENT_DOMAIN_GROUP, response.data);
        return response;
      });
    } catch (error) {
      dispatch('application/openSnackbar', {
        message: error.message,
      }, { root: true });
      throw error;
    } finally {
      dispatch('application/finishLoading', null, { root: true });
    }
  },
  async create({ dispatch }, group) {
    dispatch('application/startLoading', null, { root: true });
    try {
      return await DomainGroupAPI.create(group);
    } catch (error) {
      dispatch('application/openSnackbar', {
        message: error.message,
      }, { root: true });
      throw error;
    } finally {
      dispatch('application/finishLoading', null, { root: true });
    }
  },
  async update({ dispatch }, { domainGroupId, group }) {
    dispatch('application/startLoading', null, { root: true });
    try {
      const payload = group;
      delete payload.id;
      return await DomainGroupAPI.update(domainGroupId, payload);
    } catch (error) {
      dispatch('application/openSnackbar', {
        message: error.message,
      }, { root: true });
      throw error;
    } finally {
      dispatch('application/finishLoading', null, { root: true });
    }
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/domain-groups/actions.js